import { createVideoThumbnails, lastGalleryIndex, mapVariants } from './helpers';

const defaultStoreName = 'product';

const getProduct = (state, storeName = defaultStoreName) => (state && state[storeName]) || {};
const getProductDetails = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).details || {};
const getVariantMatrix = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).variantMatrix || [];
const isLoading = (state, storeName = defaultStoreName) => getProduct(state, storeName).loading;
const getVariantOptions = (state, storeName = defaultStoreName) =>
    mapVariants(getVariantMatrix(state, storeName));
const isFocused = (state, storeName = defaultStoreName) => getProduct(state, storeName).focused;
const getProductCode = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).code || '';
const getProductName = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).name || '';
const getDailyOffer = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).dailyOffer;
const getSelectedVariant = (state, storeName = defaultStoreName, code) => {
    const currentProductCode = code || getProductCode(state, storeName);
    return (
        getVariantMatrix(state, storeName).find(
            ({ variantOption: { code } = {} }) => currentProductCode === code,
        ) || {}
    );
};
const getProductRtsAvailable = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).realTimeStockEnabled;

const getSelectedVariantPriceData = (state, storeName = defaultStoreName) => {
    const { variantOption = {} } = getSelectedVariant(state, storeName);

    return variantOption.priceData || {};
};

const getOtherPrices = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).otherPrices || {};

const getProductBundleStatus = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).isProductBundle || false;

const getMemberPrice = (state, storeName = defaultStoreName) => {
    return getOtherPrices(state, storeName).MEMBER
        ? getOtherPrices(state, storeName).MEMBER.formattedValue
        : '';
};

const getCouponCodeValue = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).couponCodeValue || '';

const getAllProductImages = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).images || [];
const getAllProductVideos = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).videos || [];
const getProductPopupVideo = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).popupVideo;
const getGalleryImagesByFormat = (state, storeName = defaultStoreName, imgFormat) => {
    const images = getAllProductImages(state, storeName);
    return images.length
        ? images.filter(({ format, imageType }) => format === imgFormat && imageType === 'GALLERY')
        : images;
};

const getAllProductThumbnails = (state, storeName = defaultStoreName, videoThumbnailSrc) => {
    const imageThumbnails = getGalleryImagesByFormat(state, storeName, 'thumbnail');
    return [
        ...imageThumbnails,
        ...createVideoThumbnails(
            getAllProductVideos(state, storeName).length,
            lastGalleryIndex(imageThumbnails) + 1,
            videoThumbnailSrc,
        ),
    ];
};

const getQuantity = (state, storeName = defaultStoreName) => getProduct(state, storeName).quantity;
const getProductMinOrderQuantity = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).minOrderQuantity;
const getProductBaseOptions = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).baseOptions[0] || {};
const getSelectedOption = (state, storeName = defaultStoreName) =>
    getProductBaseOptions(state, storeName).selected || {};
const getInitialQuantity = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).initialQuantity || null;
const getProductToBeRemoved = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).productCodeToBeRemoved;
const getProductCodeForAddProductReview = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).productDataForAddProductReview || {};
const getColorVariantsPopupData = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).colorVariantsPopup || {};
const getPopupSelectedProductCode = (state, storeName = defaultStoreName) =>
    getColorVariantsPopupData(state, storeName).code;
const getProductPromotions = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).promotions || [];
const getProductMasterBrand = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).masterBrand || {};
const getCustomCssEnabled = (state, storeName = defaultStoreName) => {
    const { customCssUrl, abrand } = getProductMasterBrand(state, storeName);
    return customCssUrl && abrand;
};

const getProductDeliveryDates = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).deliveryDates || {};
const getProductHomeDeliveryDate = (state, storeName = defaultStoreName) =>
    getProductDeliveryDates(state, storeName).homeDelivery || {};
const getProductPickupInStoreDeliveryDate = (state, storeName = defaultStoreName) =>
    getProductDeliveryDates(state, storeName).pickupInStore || {};
const getProductRangeName = (state, storeName = defaultStoreName) =>
    getProductDetails(state, storeName).rangeName || '';
const getThresholdPromotionObject = (state, storeName = defaultStoreName) =>
    getProduct(state, storeName).thresholdPromotion;

export default {
    getProduct,
    getProductDetails,
    getVariantOptions,
    isLoading,
    isFocused,
    getProductCode,
    getProductName,
    getDailyOffer,
    getSelectedVariant,
    getSelectedVariantPriceData,
    getAllProductImages,
    getAllProductThumbnails,
    getGalleryImagesByFormat,
    getProductToBeRemoved,
    getProductCodeForAddProductReview,
    getQuantity,
    getProductBaseOptions,
    getSelectedOption,
    getInitialQuantity,
    getAllProductVideos,
    getProductPopupVideo,
    getPopupSelectedProductCode,
    getProductPromotions,
    getProductMasterBrand,
    getCustomCssEnabled,
    getProductMinOrderQuantity,
    getProductHomeDeliveryDate,
    getProductPickupInStoreDeliveryDate,
    getProductRtsAvailable,
    getProductRangeName,
    getColorVariantsPopupData,
    getOtherPrices,
    getCouponCodeValue,
    getMemberPrice,
    getProductBundleStatus,
    getThresholdPromotionObject,
};
